<template><div><component-combinator component-name="DtDescriptionList" /><h2 id="variants-and-examples" tabindex="-1" class="d-docsite--header-2">Variants and Examples <a class="header-anchor d-link d-docsite--link d-link" href="#variants-and-examples" aria-hidden="true">#</a></h2>
<h3 id="default" tabindex="-1" class="d-docsite--header-3">Default <a class="header-anchor d-link d-docsite--link d-link" href="#default" aria-hidden="true">#</a></h3>
<code-example source-code='&lt;dt-description-list
  gap=&quot;100&quot;
  :items=&quot;items&quot;
  direction=&quot;row&quot;
/&gt;'>
<div data-demo-wrapper class="d-w-500">
  <dt-description-list
    gap="100"
    :items="items"
    direction="row"
  />
</div>
</code-example>
<h3 id="column-direction" tabindex="-1" class="d-docsite--header-3">Column Direction <a class="header-anchor d-link d-docsite--link d-link" href="#column-direction" aria-hidden="true">#</a></h3>
<code-example source-code='&lt;dt-description-list
  gap=&quot;100&quot;
  :items=&quot;items&quot;
  direction=&quot;column&quot;
/&gt;'>
<div data-demo-wrapper class="d-w-500">
  <dt-description-list
    gap="100"
    :items="items"
    direction="column"
  />
</div>
</code-example>
<h3 id="long-text" tabindex="-1" class="d-docsite--header-3">Long Text <a class="header-anchor d-link d-docsite--link d-link" href="#long-text" aria-hidden="true">#</a></h3>
<code-example source-code='&lt;dt-description-list
  gap=&quot;100&quot;
  :items=&quot;longTextItems&quot;
  direction=&quot;row&quot;
/&gt;'>
<div data-demo-wrapper class="d-w-500">
  <dt-description-list
    gap="100"
    :items="longTextItems"
    direction="row"
  />
</div>
</code-example>
<h3 id="with-term-and-description-styles" tabindex="-1" class="d-docsite--header-3">With Term and Description Styles <a class="header-anchor d-link d-docsite--link d-link" href="#with-term-and-description-styles" aria-hidden="true">#</a></h3>
<code-example source-code='&lt;dt-description-list
  gap=&quot;100&quot;
  :items=&quot;items&quot;
  direction=&quot;row&quot;
  :termClass=&quot;[`d-fc-critical`, `d-fw-bold`]&quot;
  :descriptionClass=&quot;[`d-fc-positive`]&quot;
/&gt;'>
<div data-demo-wrapper class="d-w-500">
  <dt-description-list
    gap="100"
    :items="items"
    direction="row"
    :termClass="[`d-fc-critical`, `d-fw-bold`]"
    :descriptionClass="[`d-fc-positive`]"
  />
</div>
</code-example>
<h2 id="vue-api" tabindex="-1" class="d-docsite--header-2">Vue API <a class="header-anchor d-link d-docsite--link d-link" href="#vue-api" aria-hidden="true">#</a></h2>
<component-vue-api component-name="descriptionlist" /></div></template>


<script setup>
const items = [
  {
    term: 'Local time',
    description: '10:36 AM (PST)',
  },
  {
    term: 'Dialpad',
    description: '(985) 241-8617',
  },
  {
    term: 'work',
    description: '+1 604-900-7909',
  },
  {
    term: 'email',
    description: 'jackeline.na@dialpad.com',
  },
];

const longTextItems = [
  {
    term: 'Customer Intent',
    description: `Lorem ipsum dolor sit amet, consectetur adipiscing elit,
    sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
    Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.`,
  },
  {
    term: 'Three word term',
    description: ` Duis aute irure dolor in reprehenderit in voluptate velit
    esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat
    cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.`,
  },
];
</script>